const ld = require('lodash')

/**
 * Fornisce costanti e funzioni globali
 * @namespace
 */
var utils = {
  /** URL del server */
  API_URL: process.env.API_URL,

  /** Peso massimo delle immagini (in Kb) */
  MAX_IMAGE_SIZE: 50000,

  /** Timeout delle funzioni che monitorano la pagina di pagamento */
  TIMEOUT: 10000,

  /** Timeout dopo il quale viene rimosso il messaggio di errore */
  TOAST_ERR_TIMEOUT: 5000,

  /** Timeout dopo il quale viene rimosso il messaggio di info*/
  TOAST_MSG_TIMEOUT: 5000,

  /**
   * In fase di modifica di un elemento del menu sono
   * le proprietà che vengono copiate dal contenuto di un ProdVarIngr/Tag
   * per essere assegnate a customContent
   */
    PVI_CUSTOM_PROPS: [
        'descrizione',
        'descrizioneEstesa',
        'billDescription',
        'extraProps', 'varIngr',
        'prezzo', 'isComb',
        'img', 'stampante',
        'reparto',
        'hiddenUntil', 
        'limitedOrderability',
    ],

  /**
   * Ritorna l'eventuale errore da una richiesta http fallita
   * @param {Response} response - il risultato della chiamata
   * @return {string} Il messaggio di errore
   */
  getError: function(response) {
    return response.body['error_description'] ? response.body.error_description : response.statusText
  },

  /**
   * Ritorna la descrizione principale dell'oggetto
   * @param {string} object - l'oggetto
   * @return {string} La descrizione
   */
  getMainDesc: object => {
    if (!object) return ''

    if (object.tipo == 'GOBACK') return 'INDIETRO'

    return (object.descrizione && object.descrizione.find(d => d.main).contenuto) || ''
  },

  /**
   * Ritorna il campo dinamico levelDescription dei gruppi
   * nella libraria
   * @param {string} object - Il gruppo
   * @return {string} La descrizione
   */
  getLevelDescr: object => {
    if (!object) return ''
    if (object.tipo == 'GOBACK') return ''
    return object.levelDescription
  },

  /**
   * Calcola un numero che rappresenta la validità del menu
   * <pre>
   * Bit 0: Verifica le regole di orario del menu
   * Bit 1: Verifica le regole di data
   * Bit 2: Verifica le regole di giorno della settimana
   * </pre>
   * @param {object} menu - Il menu
   * @return {number} Un interno che rappresenta la somma dei 3 bit (tenendo conto del peso)
   */
  menuActiveNow: menu => {
    let roles = menu.vRoles

    let now = moment()

    if (roles.find(r => r.type == 'S')) return 1

    if (roles.find(r => r.type == 'M')) return 0

    let dayRoles = roles.filter(r => r.type == 'G')

    let dayMatch = dayRoles.some(r => {
      return r.content.find(day => day == now.get('day'))
    })
      ? '1'
      : '0'

    let periodRoles = roles.filter(r => r.type == 'P')

    let periodMatch = periodRoles.some(r => {
      let range = moment.range(moment(r.content.dateStart), moment(r.content.dateStop))
      return range.contains(now)
    })
      ? '1'
      : '0'

    let timeRoles = roles.filter(r => r.type == 'O')

    let timeMatch = timeRoles.some(r => {
      let range = moment.range(moment(r.content.timeStart, 'HH:mm'), moment(r.content.timeStop, 'HH:mm'))
      return range.contains(now)
    })
      ? '1'
      : '0'

    return parseInt(`${dayMatch}${periodMatch}${timeMatch}`, 2)
  },

  /**
   * Ritorna il prezzo principale dato il listino
   * @param {string} object - L'oggetto
   * @param {string} listino - Id del listino
   * @param {string} [specific=null] - Match con proprietà when del prezzo (prod/var)
   * @param {string} [togli=null] - Usa proprietà prezzom del prezzo se true altrimento prezzop
   * @return {object} { daListino: boolean, tipo: string, prezzo: number }
   */
  getMainPrezzo: (object, listino, specific = null, togli = false) => {
    if (object.prezzo.some(p => p === null)) return { daListino: true, prezzo: 0 }

    let when = !specific ? 'prod' : specific
    let pOrm = togli ? 'prezzom' : 'prezzop'

    let findByListino = object.prezzo.find(p => p.main && p.livello == 1 && p.when == when && p.listino == listino)
    if (!findByListino) {
      let fuoriL = object.prezzo.find(p => p.main && p.livello == 1 && p.when == when)
      return { daListino: false, tipo: fuoriL.tipo, prezzo: fuoriL[pOrm] }
    } else return { daListino: true, tipo: findByListino.tipo, prezzo: findByListino[pOrm] }
  },

  /**
   * Imposta il prezzo principale dell'oggetto del listino indicato
   * se manca viene aggiunto
   * @param {string} object - L'oggetto
   * @param {string} listino - Id del listino
   * @param {string} [specific=null] - Match con proprietà when del prezzo (prod/var)
   * @param {string} prezzo - Il prezzo
   * @return {object} L'oggetto di partenza con il prezzo modificato
   */
  setMainPrezzo: (object, listino, specific = null, prezzo) => {
    let when = !specific ? 'prod' : specific
    let findByListino = object.prezzo.find(p => p.main && p.livello == 1 && p.when == when && p.listino == listino)
    if (!findByListino) {
      object.prezzo.push({
        valuta: 'EUR',
        prezzop: prezzo,
        prezzom: '0.0',
        main: true,
        when: when,
        listino: listino,
        livello: 1,
        tipo: 1
      })
    } else {
      findByListino.prezzop = prezzo
    }

    return object
  },

  /**
   * Ritorna l'url completo dell'immagine
   * @param {string} img - L'url relativo dell'immagine
   * @return {string} L'url completo
   */
  getImgUrl: (img, w = null, h = null, crop = false) => {
    let resizer = ``
    if (w) resizer += `${resizer.length == 0 ? '?' : '&'}w=${w}`
    if (h) resizer += `${resizer.length == 0 ? '?' : '&'}h=${h}`
    if (crop) resizer += `${resizer.length == 0 ? '?' : '&'}crop`

    resizer += `${resizer.length == 0 ? '?' : '&'}v=${moment().unix()}`

    if (img != null) {
      if (img.indexOf(';base64') != -1) {
        return img
      } else {
        return module.exports.API_URL + img + resizer
      }
    } else {
      return module.exports.API_URL + '/storage/placehold_piatto.jpg'
    }
  },

  /**
   * Oggetto -> JSON ==> JSON -> Oggetto
   * @param {string} obj - L'oggetto da copiare
   * @return {string} L'oggetto clonato
   */
  clone: obj => JSON.parse(JSON.stringify(obj)),

  /**
   * Controlla se l'oggeto è un prodotto
   * @param {string} object - L'oggetto
   * @return {boolean} Esito
   */
  isProdotto: object => (object.hasOwnProperty('extraProps') ? object.extraProps.isProdotto : false),
  /**
   * Controlla se l'oggeto è una variante
   * @param {string} object - L'oggetto
   * @return {boolean} Esito
   */
  isVariante: object => (object.hasOwnProperty('extraProps') ? object.extraProps.isVariante : false),
  /**
   * Controlla se l'oggeto è un ingrediente
   * @param {string} object - L'oggetto
   * @return {boolean} Esito
   */
  isIngrediente: object => (object.hasOwnProperty('extraProps') ? object.extraProps.isIngrediente : false),

  /**
   * Crea un UUID temporaneo da assegnare alle righe del menu non ancora salvate
   * @return {string} L'id generato
   */
  getTmpId: () => {
    return 'TMP-xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  },

  /** Template dell'oggetto tavolo */
  tavoloTpl: class tavoloTpl {
    /**
     * @param {string} descrizione - Nome del tavolo
     * @param {string} ctvlx - Codice Tavolinux.
     */
    constructor(descrizione, ctvlx) {
      this.descrizione = descrizione
      this.ctvlx = ctvlx
      this.paymentOverride = {
        when: null,
        how: null
      }
    }

    newTavolo() {
      let nT = Object.assign({}, this)
      return nT
    }
  },

  /** Template dell'oggetto tag ( gruppo ) */
  tagTpl: class tagTpl {
    /**
     * @param {string} descrizione - Descrizione del tag
     */
    constructor(descrizione) {
      this.ctvlx = null
      this.tipo = 'tag'
      this.padre = null
      this.stampante = ''
      this.reparto = '1'
      this.descrizione = [{ lingua: 'IT', main: true, contenuto: descrizione }]
      this.varIngr = []
      this.img = null
      this.extraProps = {
        prodMaxVar: ''
      }
    }

    newTag() {
      let nG = Object.assign({}, this)
      // add extended description to tag
      nG.descrizioneEstesa = [{ lingua: 'IT', main: true, contenuto: '' }]
      return nG
    }
  },

  /** Template dell'oggetto menu */
  menuTpl: class menuTpl {
    /**
     * @param {string} descrizione - Descrizione del menu
     * @param {string} listino - Listino utilizzato dal menu
     */
    constructor(descrizione, listino) {
      this.vRoles = [{ type: 'S' }]
      this.listino = listino
      this.descrizione = [
        {
          lingua: 'IT',
          main: true,
          contenuto: descrizione
        }
      ]
      this.menuDiscount = {
        homeValue: '0',
        shopValue: '0',
        homeIsPercentage: false,
        shopIsPercentage: false
      }
      this.deliveryPriceModifiers = {
        chargeFee: '0',
        freeDeliveryThreshold: '0',
        chargeType: 'fixed',
        minimumDeliverableOrder: '0'
      }
      this.googleMatrixDeliveryCostPerDistance = [
        {
          isActive: true,
          type: 'distance',
          cost: '',
          distanceThreshold: '',
          minCostThresholdForCustomCost: '',
          customCost: '',
          minimumOrderThreshold: ''
        },
        {
          isActive: false,
          type: 'distance',
          cost: '',
          distanceThreshold: '',
          minCostThresholdForCustomCost: '',
          customCost: '',
          minimumOrderThreshold: ''
        },
        {
          isActive: false,
          type: 'distance',
          cost: '',
          distanceThreshold: '',
          minCostThresholdForCustomCost: '',
          customCost: '',
          minimumOrderThreshold: ''
        },
        {
          isActive: false,
          type: 'distance',
          cost: '',
          distanceThreshold: '',
          minCostThresholdForCustomCost: '',
          customCost: '',
          minimumOrderThreshold: ''
        },
        {
          isActive: false,
          type: 'distance',
          cost: '',
          distanceThreshold: '',
          minCostThresholdForCustomCost: '',
          customCost: '',
          minimumOrderThreshold: ''
        }
      ]
    }

    newMenu() {
      let nM = Object.assign({}, this)
      return nM
    }
  },

  /** Template dell'oggetto listino */
  listinoTpl: class listinoTpl {
    /**
     * @param {string} descrizione - Descrizione del listino
     */
    constructor(descrizione) {
      this.used = true
      this.valid = 1
      this.dateStart = null
      this.dateStop = null
      this.descrizione = descrizione
    }

    newListino() {
      let nL = Object.assign({}, this)
      return nL
    }
  },

  /** Template dell'oggetto listino */
  menuRowTpl: class MenuRowTpl {
    /**
     * @param {string} menu - L'id del menu a cui appartiene
     * @param {string} content - L'id dell'oggetto a cui fa riferimento
     * null per tag dinamici e combinazioni
     * @param {number} ordering - Posizione della riga
     * @param {string} parent - Id della riga padre
     */
    constructor(menu, content, ordering, parent) {
      this._id = module.exports.getTmpId()
      this._menu = menu
      this.content = content
      /** Schema a cui si riferisce il content ( ProdVarIngr / Tag ) */
      this.contentType = null
      /** Proprieta custom che differenziano l'oggetto del menu da quello nella libreria */
      this.customContent = {}
      this.ordering = ordering
      this.parent = parent
      this.hiddenUntil = null
    }

    rowProd(customContent) {
      let nMR = Object.assign({}, this, { contentType: 'ProdVarIngr', customContent: customContent })
      return nMR
    }

    rowGroup(customContent) {
      let nMR = Object.assign({}, this, { contentType: 'Tag', customContent: customContent })
      return nMR
    }

    rowComb(customContent) {
      let nMR = Object.assign({}, this, { contentType: 'Tag', customContent: customContent })
      return nMR
    }
  },

  /** Template dell'oggetto prodotto */
  prodTpl: class prodTpl {
    /**
     * @param {string} descrizione - La descrizione del prodotto
     * @param {string} listino - Listino a cui vengono assegnati i prezzi di default
     * @param {string} tipo - Tipo iniziale del prodotto ( usat solo per differenziare tra Tag e ProdVarIngr )
     */
    constructor(descrizione, listino, tipo) {
      this.barCodes = []
      this.ctvlx = null
      this.orderDescription = ''
      this.billDescription = [{ lingua: 'IT', main: true, contenuto: '' }]
      this.tipo = tipo
      this.stampante = null
      this.reparto = '1'
      this.prezzo = [
        { valuta: 'EUR', prezzop: 0, prezzom: 0, main: true, when: 'prod', listino: listino, livello: 1, tipo: 1 },
        { valuta: 'EUR', prezzop: 0, prezzom: 0, main: true, when: 'var', listino: listino, livello: 1, tipo: 1 }
      ]
      this.varIngr = []
      this.tags = []
      this.descrizione = [{ lingua: 'IT', main: true, contenuto: descrizione }]
      this.descrizioneEstesa = [{ lingua: 'IT', main: true, contenuto: '' }]
      this.img = null
      this.constraintTags = []
      this.isFavorite = false
      this.noProductionCost = false
      this.extraProps = {
          imageType: 'L',
          isProdotto: true,
          isVariante: false,
          isIngrediente: false,
          iconeAllergeni: [],
          vegano: false,
          vegetariano: false,
          surgelato: false,
          toglibile: false,
          prodMaxVar: '',
          quantificabile: false,
          a_peso: false,
          onlyCreditCard: false,
          coperto: false
      }
    }

    newProdVarIngr() {
      this.tipo = 'prod'
      let nP = Object.assign({}, this)
      return nP
    }

    newVariante() {
      this.tipo = 'var'
      let nV = Object.assign({}, this, {
        extraProps: Object.assign({}, this.extraProps, { isProdotto: false, isVariante: true })
      })
      return nV
    }

    newIngrediente() {
      this.tipo = 'ingr'
      let nI = Object.assign({}, this, {
        extraProps: Object.assign({}, this.extraProps, { isProdotto: false, isIngrediente: true })
      })
      return nI
    }

    newComb() {
      let nC = Object.assign({}, this)
      return nC
    }
  },
  /**
   * Template del 'content' della riga
   */
  content: class content {
    constructor(content, customContent = {}) {
      const merged = Object.assign({}, content, customContent)
      Object.keys(merged).forEach(key => {
        this[key] = ld.cloneDeep(merged[key])
      })
    }
  },
  /**
   * Converte un prezzo nei diversi formati
   * @param {string} num - Il numero
   * @return {object} Le funzioni di conversione
   */
  toNumeral: num => {
    return {
      /* Da EN a float */

      value: () => numeral(num, 'en').value(),
      /* Da EN a EN formattato */

      format: () => numeral(num, 'en').format('0.00', null, 'en'),
      /* Da EN a IT formattato */

      toShow: () => numeral((num && num.replace(/,/g, '.')) || null, 'en').format('0,0.00', null, 'it'),
      /* Da IT a IT formattato */

      fix: () => numeral(num, 'it').format('0,0.00', null, 'it'),
      /* Da IT a EN formattato */

      convert: () => numeral(num, 'it').format('0.00', null, 'en')
    }
  },

  dataURItoBlob: dataURI => {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString
    if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1])
    else byteString = unescape(dataURI.split(',')[1])

    // separate out the mime component
    var mimeString = dataURI
      .split(',')[0]
      .split(':')[1]
      .split(';')[0]

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length)
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }

    return new Blob([ia], { type: mimeString })
  }
}

module.exports = utils



// WEBPACK FOOTER //
// ./src/utils.js